import { createApp } from 'vue';
import { ElLoading } from 'element-plus';
import axios from 'axios';
import store from './store';
import router from './router';

// import VueGtm from '@gtm-support/vue2-gtm';
/*import index from './router';
import companyRouter from './router/companyRouter';*/
import { detectMarketFromLocation } from './detect-market';
import App from './App.vue';
import interceptor from './resources/response-interceptor';
import vuetify from './plugins/vuetify';
import Vue3TouchEvents from 'vue3-touch-events';
import MazInputPhoneNumber from 'maz-ui/components/MazInputPhoneNumber';
import { io } from 'socket.io-client';
import 'altcha';

import './registerServiceWorker';

import 'vue-color/style.css';
import 'maz-ui/styles';
// Tailwind + shadcn-vue, for every component: only `tw:` classes and [data-slot] elements are styled
import '@/assets/css/tailwind.css';

import { MazUi } from 'maz-ui/plugins/maz-ui';
import { enginioMazTheme } from './plugins/mazui-theme';
import { en } from '@maz-ui/translations';

import IconComponent from './stories/components/IconComponent/IconComponent.vue';
import Modal from './stories/components/Modal/Modal.vue';
import WarningPopup from './stories/components/WarningPopup/WarningPopup.vue';
import GlobalMixin from './mixins/GlobalMixin.vue';

import { priceFilter } from './views/v2/utils/priceFormatter';


const market = detectMarketFromLocation(window.location);
const originAndMarket = `${window.origin}/${market}`;
function setBasePath () {
  if (!market) return;
  axios.defaults.baseURL = `/${market}`;
}

setBasePath();
axios.defaults.headers.common['local-language'] = localStorage.getItem('localLanguage');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const app = createApp(App as any)

app.component('MazInputPhoneNumber', MazInputPhoneNumber);
app.component('iconComponent', IconComponent);
app.component('modal', Modal);
app.component('warningPopup', WarningPopup);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.mixin(GlobalMixin as any);

// app.config.globalProperties.$http = axios;
app.use(router);
app.use(store);
app.use(ElLoading);
app.use(vuetify);
app.use(MazUi, { theme: { preset: enginioMazTheme, colorMode: 'light' }, translations: { messages: { en } } });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
app.use(Vue3TouchEvents as any);

// Our custom filter that we use in Quoting system for price displaying in different formats
app.use(priceFilter);

const host = window.location.host;

// const socket = io(originAndMarket);
const socket = io(window.origin, {
  transports: ['websocket'],
  upgrade: false // Disable HTTP long-polling
});

socket.on('connect', () => {
  console.log('WebSocket connection established');
});

socket.on('connect_error', (error) => {
  console.log('WebSocket connection error:', error);
});
app.config.globalProperties.$socket = socket;

// default dpAnalytics
app.config.globalProperties.$dpAnalytics = (data: unknown) => {
  // Enginio dashboard
  let defaultDashboard = '6038c81007c62ebc88353c9a';
  if (import.meta.env.MODE !== 'production' || host.includes('test.enginio')) {
    console.log('Insights: ', data);
  } else {
    axios.post(`https://dp-insights.com/api/observations`, data, {
      auth: {
        username: 'client',
        password: localStorage.getItem('dashboard') || defaultDashboard,
      }
    });
  }
};

// Enable GTM
/*app.config.globalProperties.$enableGTM = (enabled = false) => {
  Vue.use(VueGtm, {
    id: 'GTM-NDNDN94',
    enabled, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    debug: true, // Whether or not display console logs debugs (optional)
    // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    // compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    // nonce: '2726c7f26c', // Will add `nonce` to the script tag
    // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  });
};*/

// For translation with variables to work properly

// can be used anywhere in the frontend
// JS:
// console.log("hello: ${name}!".interpolate({ name: 'Anton' }));
// HTML:
// {{ "hello: ${name}!".interpolate({ name: 'Anton' }) }}

String.prototype.interpolate = function (params) {
  return this.replace(/\$\{[^}]+\}/g, (match) => {
    const key = match.slice(2, -1);
    const value = params[key];
    return value === undefined ? '' : String(value);
  });
}


// Wait for the initial navigation to complete so $route.params are populated before App.mounted()
router.isReady().then(() => app.mount('#app'));
